module.exports = __webpack_public_path__ + "img/giza.a5af58f2.jpg";